import React, { useContext } from 'react'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import { MessageFormat } from '@paypalcorp/worldready'
import { secondaryHeader } from '../config'
import { fptiCustomClick, serverData } from '../utils'
import { Col, Row, TabPanel, Tabs } from '@paypalcorp/pp-react'
import { string, element, number } from 'prop-types'

const SecondaryHeader = ({ children, selectedTabId, selectedTabIndex }) => {
  const worldReady = useContext(WorldReadyContext)

  const filteredHeader = secondaryHeader.map((headerElement) => {
    return {
      ...headerElement,
      label: new MessageFormat(worldReady, {
        id: headerElement.label,
      }).format(),
    }
  })

  const handleHeaderLinksClick = (event, tabIdxClicked) => {
    fptiCustomClick(secondaryHeader[tabIdxClicked].fptiClickData)
    window.location.href = secondaryHeader[tabIdxClicked].link
  }

  const renderTabPanels = () =>
    secondaryHeader.map(({ id, panelId, containerClass }) => (
      <TabPanel id={panelId} key={id} className={containerClass}>
        {id === selectedTabId && children}
      </TabPanel>
    ))

  return (
    <Row className="one-section-only" noGutters>
      {serverData.isNative ? (
        <Col md={{ span: 12 }}>{children}</Col>
      ) : (
        <Col id="dwColumn" md={{ span: 12 }}>
          <Tabs
            name="SecondaryHeaderLinks"
            selectedTabIdx={selectedTabIndex}
            tabs={filteredHeader}
            onClick={handleHeaderLinksClick}
            tabClassName="subHeader-tab"
            center
          >
            {renderTabPanels()}
          </Tabs>
        </Col>
      )}
    </Row>
  )
}

SecondaryHeader.propTypes = {
  selectedTabIndex: number.isRequired,
  selectedTabId: string.isRequired,
  children: element.isRequired,
}

export default SecondaryHeader
